<template>
  <div>
    <div style="margin: 15px" class="not-print">
      <b-btn @click="print()" size="sm" variant="primary">Imprimir</b-btn>

      <b-btn
        @click="showFilters = !showFilters"
        size="sm"
        variant="primary"
        class="ml-4"
      >
        <i class="fas fa-filter" /> Mais Filtros
      </b-btn>
    </div>
    <div class="not-print">
      <b-collapse class="ml-4 mb-3" v-model="showFilters">
        <b-form-checkbox-group
          v-model="payment_method"
          :options="options"
          @change="select()"
          switches
        ></b-form-checkbox-group>
      </b-collapse>
    </div>

    <div class="row" style="margin: 3px">
      <div class="col">
        <b-card :title="title">
          <br />
          <div v-if="shift">
            <hr />
            <drawer-status-label class="mb-2" :shift="shift" />
          </div>
        </b-card>
      </div>
    </div>
    <div class="row" style="margin: 3px">
      <div class="col">
        <div class="card">
          <table class="table table-sm">
            <thead>
              <tr>
                <th style="text-align: center" scope="col">Data</th>
                <th style="text-align: center" scope="col">Descrição</th>
                <th style="text-align: center" scope="col">Plano de contas</th>
                <th style="text-align: center" scope="col">
                  Forma de pagamento
                </th>
                <th style="text-align: center" scope="col">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in accountTransactions" :key="index">
                <td style="text-align:center">
                  {{ row.created_at | dateTimeBr }}
                </td>
                <td style="text-align: center">
                  {{ row.description }}
                  <small v-if="row.origin == 'br' || row.origin == 'bp'">
                    (Doc.: {{ row.bill_payment_join_bill[0].document }})
                  </small>
                  <template
                    v-if="
                      row.origin == 'br' ||
                      row.origin == 'o' ||
                      row.origin == 'bp'
                    "
                  >
                    <template v-if="row.person">
                      <br />
                      <small>{{ row.person.name }} </small>
                      <small class="text-muted"
                        >#{{ row.person.person_code }}</small
                      >
                    </template>
                    <template v-if="!row.person && row.origin == 'o'">
                      <br />
                      <small>Consumidor Final</small>
                    </template>
                  </template>
                </td>
                <td style="text-align: center">
                  {{ getAccountPlan(row) }}
                </td>
                <td style="text-align: center">
                  <payment-method-badge :paymentMethod="row.payment_method" />
                </td>
                <td style="text-align: center">
                  <account-transaction-value-label
                    :value="row.value"
                    :status="row.status"
                    :payment-method="row.payment_method"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-borderless">
            <thead>
              <account-resume-card-drawer :account-resume="accountResume" />
            </thead>
          </table>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>
<script>
import AccountResumeCardDrawer from "../../components/account/sections/AccountResumeCardDrawer.vue";
import AccountTransactionValueLabel from "../../components/account/sections/AccountTransactionValueLabel.vue";
import DrawerStatusLabel from "../../components/account/sections/DrawerStatusLabel.vue";
import PaymentMethodBadge from "../../components/account/sections/PaymentMethodBadge.vue";
import InfoCard from "../../components/sections/dashboard/InfoCard.vue";
export default {
  components: {
    PaymentMethodBadge,
    InfoCard,
    AccountResumeCardDrawer,
    DrawerStatusLabel,
    AccountTransactionValueLabel,
  },

  data() {
    return {
      payment_method: [],
      accountTransactions: {},
      accountResume: {},
      shift: {
        ended_by_user: {},
        started_by_user: {},
      },
      showFilters: false,
      selected: [], // Must be an array reference!
      options: [
        { text: "Dinheiro", value: "1" },
        { text: "Cheque", value: "2" },
        { text: "Cartão Credito", value: "3" },
        { text: "Cartão Debito", value: "4" },
        { text: "Crediário", value: "5" },
        { text: "Boleto Bancário", value: "15" },
        { text: "Depósito Bancário", value: "16" },
        { text: "PIX", value: "17" },
        { text: "Carteira Digital", value: "18" },
        { text: "Outros", value: "99" },
      ],
    };
  },
  created() {
    this.select();
    this.$store.commit("pageHasLoaded");
  },

  computed: {
    title() {
      return "Relatório: " + this.$route.params.account;
    },
  },
  methods: {
    print() {
      window.print();
    },
    getAccountPlan(transaction) {
      if (transaction.origin == "o") {
        return " Receita de vendas";
      }

      if (transaction.origin != "o") {
        if (transaction.account_plan) {
          return transaction.account_plan.description;
        }
      }
    },
    async select() {
      await this.$store
        .dispatch("accountTransaction/getDrawerTransactions", {
          id: this.$route.params.id,
          shift_id: this.$route.params.shift_id,
          payment_method: this.payment_method,
        })
        .then((response) => {
          this.accountTransactions = response.data.accountTransactions;
          this.shift = response.data.shift;
          this.getResume();
        })
        .catch((error) => {
          this.error = error;
        });
    },

    async getResume() {
      await this.$store
        .dispatch("drawer/getDrawerResume", {
          account_id: this.$route.params.id,
          shift_id: this.$route.params.shift_id,
        })
        .then((response) => {
          this.accountResume = resumeResponse.data;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  width: 297mm;
  min-height: 210mm;
  padding: 0.5cm;
  margin: 0.5cm;
  border: 1px #d3d3d3 solid;
  /*    border-radius: 5px;*/
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .not-print {
    display: none;
  }
}
hr.color {
  border: 1px solid black;
}
</style>
